// app/[locale]/thailand-tapioca-starch-manufacturing-export-services-fcl-lcl/OurServicesClient.tsx
"use client";

import Hero from "@/app/components/thailand-tapioca-starch-manufacturing-export-services-fcl-lcl/Hero";
import FooterContact from "@/app/components/FooterContact";
import PoonPhol from "@/app/components/thailand-tapioca-starch-manufacturing-export-services-fcl-lcl/PoonPhol";
import Steps from "@/app/components/thailand-tapioca-starch-manufacturing-export-services-fcl-lcl/Steps";
import ManufacturerContent from "@/app/components/thailand-tapioca-starch-manufacturing-export-services-fcl-lcl/ManufacturerContent";
import Map from "@/app/components/home/Map";

export default function OurServicesClient() {
  return (
    <>
      <Hero />
      <PoonPhol />
      <Steps />
      <ManufacturerContent />
      <Map />
      <FooterContact />
    </>
  );
}
